import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../Common/Breadcrumb"
import PropTypes from "prop-types"
import ReportingBreadcrumbTitle from "../../pages/Reporting/ReportingBreadcrumbTitle"
import ClientsList from "./ClientsList"
import ModifiedMetaTags from '../ModifiedMetaTags/index';

const ClientsListPage = ({title = '', prevTitle = 'Dashboard', prevLink = '/', href = ''}) => {
  return (
    <React.Fragment>
      <div className="page-content">
        <ModifiedMetaTags title={`${title || 'Client'} | Mobihunter`}/>

        <Container fluid>
          <Breadcrumbs
            title={prevTitle}
            breadcrumbItem={title}
            link={prevLink}
            // customBreadcrumbItem={<ReportingBreadcrumbTitle title={title}/>}
          />

          <ClientsList
            pathname={href}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

ClientsListPage.propTypes = {
  title: PropTypes.string,
  prevTitle: PropTypes.string,
  prevLink: PropTypes.string,
  href: PropTypes.string,
}

export default (ClientsListPage)
